import './App.css';
import Router from './Components/Routers/Router';

function App() {
  return (
    <div className="App">
    <Router />
    </div>
  );
}

export default App;
